module.exports = __webpack_public_path__ + "static/media/1- Gain de temps.b37c6dd9.png";